export const INITIAL_DATE = 0;
// Pension licenses cases
export const SUSPENSION_LICENSE_ID = '64d1ee3e-eaff-418d-bd89-eb95bc08eb41';
export const LICENSE_NR = '78eb9d57-c8d3-416d-a331-4ecd20ffa32b';
